import { mercuryApi } from '$api'
import { RosteredShift, transformRosteredShiftOnGet } from '$models'
import { createQueryString } from '$utils'
import { Dayjs } from 'dayjs'

/**
 * Get rostered shifts by date range
 * @returns an array of invoices
 */
export const getAll = async (
  startTime: Dayjs,
  endTime: Dayjs,
  rosterId?: string,
  includeDeleted?: boolean
): Promise<RosteredShift[]> => {
  const query = createQueryString({
    startTime: startTime.utc().format(),
    endTime: endTime.utc().format(),
    rosterId,
    includeDeleted,
  })

  const result = await mercuryApi.get<RosteredShift[]>(
    `/time/rostered-shifts?${query}`
  )

  return result.map(transformRosteredShiftOnGet)
}
